import { BaseComponent } from '../base.component';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../shared.service';
import { ImageModel, TagModel } from '../shared.model';
import { NgxGalleryImage, NgxGalleryOptions, NgxGalleryComponent } from 'ngx-gallery';
import { FormControl } from "@angular/forms";

@Component({
    selector: 'image-preview',
    templateUrl: 'image-preview.component.html',
    styleUrls: ['image-preview.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ImagePreviewComponent extends BaseComponent implements OnInit {
    @Input() PreviewImage: ImageModel[];
    @Input() TagList: TagModel[];
    @Input() AttachmentId: number;
    @Output() Close = new EventEmitter();
    rotateDegree: number = 360;
    zoomPt: number = 0;
    maxWidth: string = '100%';
    currentImage: string;
    currentFile: string;
    currentIndex: number = 0;
    totalImage: number;
    isZoomIn = false;
    isZoomOut = true;
    imgHeight: string = '';
    imgWidth: string = '';
    imgtranslate: string = 'translate(0%, -50%)';
    imgRotate: string = 'rotate(0deg)';
    imgtop: string = '50%';
    imgleft: string = '0%';
    csstranslate: string;
    galleryOptions: NgxGalleryOptions[];
    galleryImages: NgxGalleryImage[];
    isPreviewOpen: boolean = false
    @ViewChild('gallery') gallery: NgxGalleryComponent;
    tagName = new FormControl();
    previewImageList: ImageModel[];
    isTagEnabled: boolean = false;
    isInit: boolean = true;
    constructor(protected sharedService: SharedService, protected translate: TranslateService) {
        super(sharedService, translate);
    }
    ngOnInit() {
        debugger;





        this.csstranslate = this.imgtranslate + this.imgRotate;
        this.totalImage = this.PreviewImage.length;
        this.currentIndex = this.PreviewImage.indexOf(this.PreviewImage.find(p => p.AttachmentId == this.AttachmentId));
        this.currentImage = this.PreviewImage[this.currentIndex].Attachment;
        this.currentFile = this.PreviewImage[this.currentIndex].FileName;

        if (typeof this.TagList != "undefined") {
            this.isTagEnabled = true;
            this.tagName.setValue("0");
            var tagValue = this.PreviewImage[this.currentIndex].Tag;
            this.tagName.setValue(tagValue);
            this.FilterByTag(tagValue, 0);
        }
        else {
            this.getgalleryImages(this.PreviewImage);
        }

        // this.galleryOptions = [
        //     {
        //         width: '100%',
        //         height: '100%',
        //         thumbnailsColumns: 4,
        //         previewZoom: true,
        //         previewRotate: true,
        //         previewCloseOnEsc: true,
        //         imageDescription: true,
        //         linkTarget: '_blank',
        //         startIndex: this.currentIndex
        //         // previewFullscreen: true,
        //         // previewForceFullscreen: true,

        //         // fullWidth: true
        //         //   imageAutoPlay: true,
        //         //   imageAutoPlayPauseOnHover: true,
        //         //   previewAutoPlay: true,
        //         //   previewAutoPlayPauseOnHover: true,
        //         //   imageArrowsAutoHide: true,
        //         //   thumbnailsArrowsAutoHide: true
        //     }
        // ];
        // this.PreviewImage.forEach(x => {
        //     this.galleryImages.push({
        //         small: 'data:image/png;base64,' + x.Attachment,
        //         medium: 'data:image/png;base64,' + x.Attachment,
        //         big: 'data:image/png;base64,' + x.Attachment,
        //         description: x.Description
        //     });
        // });
        debugger
        var list = this.TagList;

        // // this.tagName.valueChanges.subscribe(value => {
        // //     debugger;
        // //     if (value != 0) {
        // //         this.previewImageList = this.PreviewImage.filter(f => f.Tag == value);
        // //     }
        // //     else {
        // //         this.previewImageList = this.PreviewImage;
        // //     }
        // //     this.getgalleryImages(this.previewImageList);
        // //     if (!this.isInit) {
        // //         this.currentIndex = 0;
        // //         this.currentImage = this.previewImageList[this.currentIndex].Attachment;
        // //         this.currentFile = this.previewImageList[this.currentIndex].FileName;
        // //     }

        // //     // this.currentIndex = this.PreviewImage.indexOf(this.PreviewImage.find(p => p.AttachmentId == this.AttachmentId));
        // //     // this.currentImage = this.PreviewImage[this.currentIndex].Attachment;
        // //     // this.currentFile = this.PreviewImage[this.currentIndex].FileName;


        // // });
        // // if (this.isTagEnabled == true) {
        // //     var tagValue = this.PreviewImage[this.currentIndex].Tag;
        // //     // this.tagName.setValue(tagValue);
        // // }
        // // this.isInit = false;

    }

    getgalleryImages(previewImage: any) {
        this.galleryImages = [];
        this.galleryOptions = [
            {
                width: '100%',
                height: '100%',
                thumbnailsColumns: 4,
                previewZoom: true,
                previewRotate: true,
                previewCloseOnEsc: true,
                imageDescription: true,
                linkTarget: '_blank',
                startIndex: this.currentIndex
                // previewFullscreen: true,
                // previewForceFullscreen: true,

                // fullWidth: true
                //   imageAutoPlay: true,
                //   imageAutoPlayPauseOnHover: true,
                //   previewAutoPlay: true,
                //   previewAutoPlayPauseOnHover: true,
                //   imageArrowsAutoHide: true,
                //   thumbnailsArrowsAutoHide: true
            }
        ];
        previewImage.forEach(x => {
            this.galleryImages.push({
                small: 'data:image/png;base64,' + x.Attachment,
                medium: 'data:image/png;base64,' + x.Attachment,
                big: 'data:image/png;base64,' + x.Attachment,
                description: x.Description
            });
        });
    }
    closePopup() {
        this.Close.emit();
    }
    resetImage() {
        this.rotateDegree = 360;
        this.zoomPt = 0;
        this.maxWidth = '100%';
        this.isZoomIn = false;
        this.isZoomOut = true;
        this.rotateCss(this.rotateDegree);
        this.setHeightWidth(this.zoomPt);
        if (this.imgleft == '')
            this.imgleft = '0%';
        else
            this.imgleft = '';

    }
    ZoomIn() {
        if (this.zoomPt < 5) {
            this.zoomPt += 1;
            this.imgtranslate = '';
            this.imgtop = '';
            this.setHeightWidth(this.zoomPt);
            this.maxWidth = '';
            this.isZoomOut = false;
        }
        else {
            this.isZoomIn = true;
        }

    }
    ZoomOut() {
        if (this.zoomPt != 0) {
            this.zoomPt -= 1;
            this.imgtranslate = '';
            this.imgtop = '';
            if (this.imgtop == '')
                this.imgtop = '0%';
            else
                this.imgtop = '';
            if (this.imgleft == '')
                this.imgleft = '0%';
            else
                this.imgleft = '';
            this.setHeightWidth(this.zoomPt);
        }
        if (this.zoomPt == 0) {
            this.isZoomOut = true;
            this.maxWidth = '100%';
            this.setHeightWidth(this.zoomPt);
        }
        if (this.zoomPt < 5) {
            this.isZoomIn = false;
        }

    }
    setHeightWidth(zoom) {
        if (zoom == 1) {
            this.imgHeight = '600px';
            this.imgWidth = '800px';
        }
        else if (zoom == 2) {
            this.imgHeight = '720px';
            this.imgWidth = '960px';
        }
        else if (zoom == 3) {
            this.imgHeight = '840px';
            this.imgWidth = '1120px';
        }
        else if (zoom == 4) {
            this.imgHeight = '1020px';
            this.imgWidth = '1360px';
        }
        else if (zoom == 5) {
            this.imgHeight = '1200px';
            this.imgWidth = '1600px';
        }
        else {
            this.imgHeight = '';
            this.imgWidth = '';
            this.imgtranslate = 'translate(0%, -50%)';
            this.imgtop = '50%';
        }
        this.csstranslate = this.imgtranslate + this.imgRotate;
    }
    rotateImageRight() {
        this.rotateDegree += 90;
        if (this.rotateDegree > 360)
            this.rotateDegree = 90;
        this.rotateCss(this.rotateDegree);
    }
    rotateImageLeft() {
        this.rotateDegree -= 90;
        if (this.rotateDegree < 90)
            this.rotateDegree = 360;
        this.rotateCss(this.rotateDegree);
    }

    rotateCss(rotateDegree) {
        if (rotateDegree == 90) {
            this.imgRotate = 'rotate(90deg)'
        }
        else if (rotateDegree == 180) {
            this.imgRotate = 'rotate(180deg)'
        }
        else if (rotateDegree == 270) {
            this.imgRotate = 'rotate(270deg)'
        }
        else {
            this.imgRotate = 'rotate(0deg)'
        }
        this.csstranslate = this.imgtranslate + this.imgRotate;
    }

    downloadImage() {      
        var byteString = window.atob(this.currentImage);
        var arrayBuffer = new ArrayBuffer(byteString.length);
        var int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([int8Array], { type: 'image/jpeg' });
        this.sharedService.downloadFile(this.currentFile, blob);
    }
    nextImage() {
        this.resetImage();
        if (this.PreviewImage.length > this.currentIndex + 1) {
            this.currentIndex += 1;
        }
        else {
            this.currentIndex = 0;
        }
        this.currentImage = this.PreviewImage[this.currentIndex].Attachment
        this.currentFile = this.PreviewImage[this.currentIndex].FileName;
    }
    previousImage() {
        this.resetImage();
        if (this.currentIndex == 0) {
            this.currentIndex = this.PreviewImage.length - 1;
        }
        else {
            this.currentIndex -= 1;
        }
        this.currentImage = this.PreviewImage[this.currentIndex].Attachment
        this.currentFile = this.PreviewImage[this.currentIndex].FileName;
    }

    previewOpen() {
        alert('previewOpen');
    }

    previewClose() {
        alert('previewClose');
    }

    galleryChangeMonitor(d: any) {
        debugger
        this.currentIndex=d.index;
        this.currentImage = this.PreviewImage[this.currentIndex].Attachment
        this.currentFile = this.PreviewImage[this.currentIndex].FileName;
    }
    setPreviewState(a: any, event: any) {
        debugger;
        var dd = this.gallery;
        if (a == 'open') {
            this.isPreviewOpen = true;
        } else if (a == 'closed') {
            this.isPreviewOpen = false;
        }
    }

    galleryImageClicked(index) {
        debugger;
        console.info('Gallery image clicked with index ', index);
    }
    galleryOpened(index) {
        debugger;
        console.info('Gallery opened at index ', index);
    }

    FilterByTag(tagName: any, firstInit) {
        debugger;
        if (tagName != "0") {
            this.previewImageList = this.PreviewImage.filter(f => f.Tag == tagName);
            if (firstInit == 0) {
                this.currentIndex = this.previewImageList.indexOf(this.previewImageList.find(p => p.AttachmentId == this.AttachmentId));
                this.currentIndex = this.currentIndex == -1 ? 0 : this.currentIndex;
            }
            else {
                this.currentIndex = 0;
            }

        }
        else {
            this.previewImageList = this.PreviewImage;
            this.currentIndex = 0;
        }
        this.currentImage = this.previewImageList[this.currentIndex].Attachment;
        this.currentFile = this.previewImageList[this.currentIndex].FileName;
        this.getgalleryImages(this.previewImageList);
    }

}
